import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import axiosInstance from "../../interceptor/axiosInstance";
import { Students } from "../../models/InstituteModel/students.model";
import { deserialize, serialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import { generatePath } from "react-router-dom";

export default class StudentService {
  static fetchStudents(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.STUDENTS_LIST, { params })
      .then((response) => {
        const students = deserialize(Students, response?.data["students"]);
        const meta = deserialize(PaginationModel, response?.data["meta"]);
        onSuccess(students, meta);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching students",
          description: "Please proceed with valid data!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static getStudentsDetails(
    studentId: number,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(generatePath(ApiRoutes.INSTITUTE_STUDENT__DETAILS, { studentId }))
      .then((response) => {
        const students = deserialize(Students, response?.data["student"]);
        onSuccess(students);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching student details",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static createStudents(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .post(ApiRoutes.STUDENTS_LIST, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating students",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }
  static updateStudent(
    studentId: number,
    data: Students,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = { student: serialize(Students, data) };
    axiosInstance
      .put(generatePath(ApiRoutes.SINGLE_STUDENT, { studentId }), payload)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in updating student",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }

  static updatePassword(
    studentId: number | undefined,
    password: string,
    onSuccess: Function,
  ) {
    const payload = { student: {password: password }};
    axiosInstance
      .put(generatePath(ApiRoutes.STUDENT_PASSWORD_UPDATE, { studentId }), payload)
      .then(() => {
        Notification({ message: "Password", description: "Password updated successfully", type: NotificationTypes.SUCCESS });
        onSuccess()
      })
      .catch((error) => {
        Notification({
          message: `${error?.response?.data?.error || "Problem in updating tutor's password"}`,
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
      })
  }

  static updatePrivateStudentPassword(
    studentId: number | undefined,
    password: string,
    onSuccess: Function,
  ) {
    const payload = { student: {password: password }};
    axiosInstance
      .put(generatePath(ApiRoutes.PRIVATE_STUDENT_PASSWORD_UPDATE, { studentId }), payload)
      .then(() => {
        Notification({ message: "Password", description: "Password updated successfully", type: NotificationTypes.SUCCESS });
        onSuccess()
      })
      .catch((error) => {
        Notification({
          message: `${error?.response?.data?.error || "Problem in updating tutor's password"}`,
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
      })
  }

  static deletePrivateStudent(
    studentId: number,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .delete(generatePath(ApiRoutes.PRIVATE_SINGLE_STUDENT, { studentId }), {})
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in deleting student",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }
  static deleteStudent(
    studentId: number,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .delete(generatePath(ApiRoutes.SINGLE_STUDENT, { studentId }), {})
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in deleting student",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }
}
